module.exports = function(bootstrap) {
    bootstrap.run(["Service", '$cookies', 'brandConfig', 'sessionData', function (Service, $cookies, brandConfig, sessionData) {
        return new Service({
            name: 'svcChangePcp',
            group: "rbsmbl",
            url: "/rbsmbl/x-services/providerInfo/change",
            cache: false,
            postData: function(thePayload) {
                var cookieValue = brandConfig.getSharedBrandCodeFromLeafUBK( sessionData.employerInfo.brandName );
                $cookies.put('umsBrand', cookieValue, { path: '/' });
                return this.post({
                    baseMessage: {
                        headerVersion: "1.0",
                        payloadVersion: "2.0",
                        additionalInfo: null
                    },
                "payload": thePayload
                });
            }
        });
    }]);
};